import { siteConfig } from "../config/site";

export function SiteFooter() {
  return (
    <footer className="w-full border-t border-ink/15 bg-surface">
      <div className="mx-auto flex w-full max-w-[1600px] items-center justify-between px-[clamp(22px,4.4vw,72px)] py-[19px] font-mono text-[10px] tracking-[.13em] text-ink/65 uppercase">
        <span>{siteConfig.domain}</span>
        <span>© {new Date().getFullYear()}</span>
      </div>
    </footer>
  );
}
